import { CurriedFunction1, CurriedFunction2, CurriedFunction3, CurriedFunction4 } from 'lodash4';
import { RegularExpression } from '../core/regular_expression';
import * as _4 from 'lodash4';

export class StringUtility {
  static getAcronym(...args: Array<string>): string {
    return _4.reduce(
      args,
      (acronym: string, arg: string = ''): string => {
        return acronym + (_4.trim(arg)[0] || '').toUpperCase();
      },
      ''
    );
  }

  static truncateString = _4.curry((totalLength: number, longString: string) => {
    return _4.truncate(longString, {
      length: totalLength
    });
  });

  static truncateWithEllipse(maxLength: number, longString: string) {
    if (_4.isEmpty(longString)) {
      return '';
    }

    if (_4.size(longString) < maxLength) {
      return longString + '\n';
    }

    let end: number = longString.lastIndexOf(' ', maxLength);
    return longString.substr(0, end) + '...';
  }

  static sanitizeString(dirtyString: string): string {
    return _4.replace(dirtyString, RegularExpression.SANITIZED_STRING, '');
  }

  static toNumericHash(word: string): number {
    return _4.reduce(
      word + '',
      (sum: number, letter: string) => {
        return sum + letter.charCodeAt(0);
      },
      0
    );
  }
}



// WEBPACK FOOTER //
// ./app/vendor/utility-ts-type/src/types/string.ts